import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProviderTypes } from '@guryou/core';
import { Block, DefaultText, FlexRow, PersonRuningIcon, RightIcon, SmallText, WorkoutIcon } from '@guryou/html-components';
import { borderDefinition, smallBorderRadius } from '@guryou/html-theme';
import { makeStyles } from '@material-ui/core/styles';
import { useOnboardContext } from 'onboard/context';

const useStyles = makeStyles({
  box: {
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
  },
});

const ProviderType = ({ type = ProviderTypes.centers }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { setPrevStateWithStep } = useOnboardContext();

  const handleClick = () => {
    setPrevStateWithStep({ providerType: type }, 2);
  };

  return (
    <Block
      className={classes.box}
      xs={12}
      md={6}
      lg={4}
      margin={4}
      border={borderDefinition()}
      borderRadius={smallBorderRadius}
      cursor="pointer"
      onClick={handleClick}
    >
      <FlexRow>
        <Block xs={10} display="flex" flexDirection="column" justifyContent="start">
          <Block margin={0} padding={1}>
            {type === ProviderTypes.centers ? <WorkoutIcon /> : <PersonRuningIcon />}
          </Block>
          <DefaultText fontWeight="800" padding={1}>
            {type === ProviderTypes.centers ? t('ONBOARD.center') : t('ONBOARD.professionals')}
          </DefaultText>
          <SmallText padding={1} fontWeight={500}>
            {type === ProviderTypes.centers ? t('ONBOARD.centerDescription') : t('ONBOARD.profDescription')}
          </SmallText>
        </Block>
        <Block xs={2} display="flex" flexDirection="row" alignItems="center" justifyContent="center">
          <RightIcon fontSize="medium" />
        </Block>
      </FlexRow>
    </Block>
  );
};

export default ProviderType;
